// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn,
.pill,
.summary-card,
.table-row,
.approved-card,
.log-item {
  transition:
    transform var(--motion-fast) var(--easing-standard),
    box-shadow var(--motion-fast) var(--easing-standard),
    border-color var(--motion-fast) var(--easing-standard),
    background var(--motion-fast) var(--easing-standard),
    color var(--motion-fast) var(--easing-standard);
}

.btn:hover:not(:disabled),
.pill:hover:not(:disabled) {
  transform: translateY(-1px);
}

.btn.primary {
  background: linear-gradient(130deg, var(--ui-accent-strong), var(--ui-accent));
  border: 1px solid rgba(14, 54, 76, 0.35);
  box-shadow: 0 12px 22px rgba(15, 56, 80, 0.25);
}

.btn.ghost {
  color: var(--ui-accent-strong);
  border-color: var(--ui-border-strong);
}

.filters,
.summary-card,
.board,
.approved-view,
.tax-view,
.attendance-view,
.locations-panel,
.db-shortcuts-panel {
  border-color: var(--ui-border);
}

.table-filters-sticky {
  position: sticky;
  top: 0.45rem;
  z-index: 8;
  backdrop-filter: blur(8px);
}

.board-table-keyvalue-mobile .table-row [data-cell-label] {
  position: relative;
}

.db-shortcuts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--ui-space-3);
}

.reportes-view {
  display: grid;
  gap: var(--ui-space-3);
}

.reportes-view-toolbar {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.eyebrow {
  margin: 0 0 0.45rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ui-accent);
}

.subtitle {
  margin-top: 0.55rem;
  line-height: 1.55;
  color: var(--ui-text-soft);
}

.auth-shell {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: clamp(1rem, 4vw, 2.5rem);
  background:
    radial-gradient(circle at 14% 8%, rgba(29, 90, 124, 0.16), transparent 42%),
    radial-gradient(circle at 88% 92%, rgba(20, 114, 79, 0.12), transparent 46%);
}

.login-card {
  width: min(540px, 100%);
  display: flex;
  flex-direction: column;
  gap: var(--ui-space-4);
  padding: clamp(1.25rem, 2vw, 2.35rem);
  border-radius: var(--ui-radius-xl);
  border: 1px solid var(--ui-border);
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.96), rgba(247, 251, 254, 0.94));
  box-shadow: var(--ui-elevation-2);
}

.login-card h1 {
  margin: 0;
  font-size: clamp(2rem, 3.2vw, 3rem);
}

.login-card label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: var(--ui-text);
  font-weight: 620;
}

.login-card input {
  min-height: 2.95rem;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  padding: 0.8rem 0.9rem;
  background: rgba(255, 255, 255, 0.9);
  color: inherit;
}

.login-card input:focus-visible {
  outline: 2px solid rgba(29, 90, 124, 0.42);
  outline-offset: 1px;
  border-color: rgba(29, 90, 124, 0.72);
  box-shadow: 0 0 0 3px rgba(29, 90, 124, 0.18);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

.auth-footnote {
  border-top: 1px solid var(--ui-border);
  margin-top: 0.25rem;
  padding-top: 0.75rem;
  color: var(--ui-text-soft);
}

@media (max-width: 960px) {
  .table-filters-sticky {
    position: static;
  }

  .board-table-keyvalue-mobile .table-head {
    display: none;
  }

  .board-table-keyvalue-mobile .table-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.4rem;
    padding: 0.85rem;
  }

  .board-table-keyvalue-mobile .table-row [data-cell-label] {
    display: grid;
    gap: 0.15rem;
  }

  .board-table-keyvalue-mobile .table-row [data-cell-label]::before {
    content: attr(data-cell-label);
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #7b8e9f;
  }

  .approved-list {
    grid-template-columns: 1fr;
  }

  .approved-card {
    display: grid;
    gap: 0.75rem;
  }

  .approved-meta {
    justify-content: space-between;
    width: 100%;
  }

  .auth-shell {
    align-items: flex-start;
    padding: 0.8rem;
  }

  .login-card {
    border-radius: var(--ui-radius-lg);
    padding: 1rem;
    gap: 0.8rem;
  }

  .login-card h1 {
    font-size: clamp(1.9rem, 7vw, 2.4rem);
  }

  .form-actions {
    justify-content: stretch;
  }

  .form-actions .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;;;;mDAKiD;AACnD;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,8EAA8E;EAC9E,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;;;;;;;;EAQE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC;;gFAE8E;AAChF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,qCAAqC;EACrC,kCAAkC;EAClC,kCAAkC;EAClC,yFAAyF;EACzF,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,WAAW;EACb;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".btn,\n.pill,\n.summary-card,\n.table-row,\n.approved-card,\n.log-item {\n  transition:\n    transform var(--motion-fast) var(--easing-standard),\n    box-shadow var(--motion-fast) var(--easing-standard),\n    border-color var(--motion-fast) var(--easing-standard),\n    background var(--motion-fast) var(--easing-standard),\n    color var(--motion-fast) var(--easing-standard);\n}\n\n.btn:hover:not(:disabled),\n.pill:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.btn.primary {\n  background: linear-gradient(130deg, var(--ui-accent-strong), var(--ui-accent));\n  border: 1px solid rgba(14, 54, 76, 0.35);\n  box-shadow: 0 12px 22px rgba(15, 56, 80, 0.25);\n}\n\n.btn.ghost {\n  color: var(--ui-accent-strong);\n  border-color: var(--ui-border-strong);\n}\n\n.filters,\n.summary-card,\n.board,\n.approved-view,\n.tax-view,\n.attendance-view,\n.locations-panel,\n.db-shortcuts-panel {\n  border-color: var(--ui-border);\n}\n\n.table-filters-sticky {\n  position: sticky;\n  top: 0.45rem;\n  z-index: 8;\n  backdrop-filter: blur(8px);\n}\n\n.board-table-keyvalue-mobile .table-row [data-cell-label] {\n  position: relative;\n}\n\n.db-shortcuts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: var(--ui-space-3);\n}\n\n.reportes-view {\n  display: grid;\n  gap: var(--ui-space-3);\n}\n\n.reportes-view-toolbar {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.eyebrow {\n  margin: 0 0 0.45rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--ui-accent);\n}\n\n.subtitle {\n  margin-top: 0.55rem;\n  line-height: 1.55;\n  color: var(--ui-text-soft);\n}\n\n.auth-shell {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  padding: clamp(1rem, 4vw, 2.5rem);\n  background:\n    radial-gradient(circle at 14% 8%, rgba(29, 90, 124, 0.16), transparent 42%),\n    radial-gradient(circle at 88% 92%, rgba(20, 114, 79, 0.12), transparent 46%);\n}\n\n.login-card {\n  width: min(540px, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: var(--ui-space-4);\n  padding: clamp(1.25rem, 2vw, 2.35rem);\n  border-radius: var(--ui-radius-xl);\n  border: 1px solid var(--ui-border);\n  background: linear-gradient(155deg, rgba(255, 255, 255, 0.96), rgba(247, 251, 254, 0.94));\n  box-shadow: var(--ui-elevation-2);\n}\n\n.login-card h1 {\n  margin: 0;\n  font-size: clamp(2rem, 3.2vw, 3rem);\n}\n\n.login-card label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  color: var(--ui-text);\n  font-weight: 620;\n}\n\n.login-card input {\n  min-height: 2.95rem;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  padding: 0.8rem 0.9rem;\n  background: rgba(255, 255, 255, 0.9);\n  color: inherit;\n}\n\n.login-card input:focus-visible {\n  outline: 2px solid rgba(29, 90, 124, 0.42);\n  outline-offset: 1px;\n  border-color: rgba(29, 90, 124, 0.72);\n  box-shadow: 0 0 0 3px rgba(29, 90, 124, 0.18);\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.auth-footnote {\n  border-top: 1px solid var(--ui-border);\n  margin-top: 0.25rem;\n  padding-top: 0.75rem;\n  color: var(--ui-text-soft);\n}\n\n@media (max-width: 960px) {\n  .table-filters-sticky {\n    position: static;\n  }\n\n  .board-table-keyvalue-mobile .table-head {\n    display: none;\n  }\n\n  .board-table-keyvalue-mobile .table-row {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.4rem;\n    padding: 0.85rem;\n  }\n\n  .board-table-keyvalue-mobile .table-row [data-cell-label] {\n    display: grid;\n    gap: 0.15rem;\n  }\n\n  .board-table-keyvalue-mobile .table-row [data-cell-label]::before {\n    content: attr(data-cell-label);\n    font-size: 0.68rem;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: #7b8e9f;\n  }\n\n  .approved-list {\n    grid-template-columns: 1fr;\n  }\n\n  .approved-card {\n    display: grid;\n    gap: 0.75rem;\n  }\n\n  .approved-meta {\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .auth-shell {\n    align-items: flex-start;\n    padding: 0.8rem;\n  }\n\n  .login-card {\n    border-radius: var(--ui-radius-lg);\n    padding: 1rem;\n    gap: 0.8rem;\n  }\n\n  .login-card h1 {\n    font-size: clamp(1.9rem, 7vw, 2.4rem);\n  }\n\n  .form-actions {\n    justify-content: stretch;\n  }\n\n  .form-actions .btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
